<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/srd8hW/tc-custom/9781633224032.jpg?1725275783936" alt="This image is the cover for the book Complete Beginner's Guide to Drawing Animals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Complete Beginner's Guide to Drawing Animals
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn to create pet portraits, wildlife scenes, and cartoon creatures with the helpful tips and step-by-step lessons in this comprehensive resource.</b><br/><br/>The Complete Beginner’s Guide to Drawing Animals starts with a thorough introduction to the essential tools and materials artists need to get started, including different types of pencils, sketchbooks, papers, erasers, and more. This helpful resource features dozens of comprehensive drawing lessons designed to teach aspiring artists how to draw a variety of animals, from lifelike pet portraits to zoo and safari animals. Artists will discover the fundamentals of drawing and techniques for rendering realistic animal textures, such as fur, feathers, whiskers, manes, and hair; creating volume; shading; developing a composition; and mastering perspective, all with the goal of drawing dozens of lifelike animals in graphite and colored pencil.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter Foster Creative Team
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Walter Foster Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e831d78